<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-container modal-container--confirm">
        <div class="modal-header padding-sm">
          {{ body }}
        </div>

        <div class="modal-footer">
          <button
            class="btn btn-style-c btn-lg"
            data-test="confirm-button-cancel"
            @click="$emit('close')"
          >
            Cancel
          </button>

          <button
            class="btn btn-style-a btn-lg"
            data-test="confirm-button-confirm"
            @click="$emit('confirm')"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    body: {
      type: String,
      default: 'Are you sure?',
    },
  },

  emits: ['close', 'confirm'],
};
</script>
